<template>
	<div class="mr-3">
		<div class="row">
			<div class="col-lg-4">
                <label for="">Descripción</label>
            </div>
			<div class="pt-1 col-lg-2 FondoDetallesTitulos">
                <label class="text-white" for="">Trimestre 1</label>
            </div>
            <div class="pt-1 col-lg-2 FondoDetallesTitulos">
                <label class="text-white" for="">Trimestre 2</label>
            </div>
            <div class="pt-1 col-lg-2 FondoDetallesTitulos">
                <label class="text-white" for="">Trimestre 3</label>
            </div>
            <div class="pt-1 col-lg-2 FondoDetallesTitulos">
                <label class="text-white" for="">Trimestre 4</label>
            </div>
		</div>
		<div :class="index%2==0 ? 'row pb-2 pt-1 fondoformfinanciera' : 'row pb-2 pt-1 fondoformfinanciera2'" v-for="(item,index) in ListaDetallesCuenta" :key="index">
			<div class="col-lg-4">
                <input readonly v-model="item.Descripcion" type="text" class="form-control">
            </div>
			<div :class="index%2==0 ? 'col-lg-2 m-auto FondoDetallesValor' : 'col-lg-2 m-auto FondoDetallesValor2'">
                
                <vue-numeric @keyup.native="GetTotalTrimestre" placeholder="$ 0" class="form-control form-finanza form-control-sm text-center" currency="$" separator="," :precision="Decimal" v-model="item.UnoT" ></vue-numeric>
            </div>
            <div :class="index%2==0 ? 'm-auto col-lg-2 FondoDetallesValor' : 'm-auto col-lg-2 FondoDetallesValor2'">
                
                <vue-numeric @keyup.native="GetTotalTrimestre" placeholder="$ 0" class="form-control form-finanza form-control-sm text-center" currency="$" separator="," :precision="Decimal" v-model="item.DosT" ></vue-numeric>
            </div>
            <div :class="index%2==0 ? 'm-auto col-lg-2 FondoDetallesValor' : 'm-auto col-lg-2 FondoDetallesValor2'">
                <vue-numeric @keyup.native="GetTotalTrimestre" placeholder="$ 0" class="form-control form-finanza form-control-sm text-center" currency="$" separator="," :precision="Decimal" v-model="item.TresT" ></vue-numeric>
            </div>
            <div :class="index%2==0 ? 'm-auto col-lg-2 FondoDetallesValor' : 'm-auto col-lg-2 FondoDetallesValor2'">
                <vue-numeric @keyup.native="GetTotalTrimestre" placeholder="$ 0" class="form-control form-finanza form-control-sm text-center" currency="$" separator="," :precision="Decimal" v-model="item.CuatroT" ></vue-numeric>
            </div>
		</div>
		<div class="row">
            <div class="col-lg-4">
                <label for="" class="color-01 bold sticky">TOTALES</label>
            </div>
            <div class="col-lg-2">
                <vue-numeric disabled placeholder="$ 0" class="form-control form-finanza form-control-sm text-center color-01 bold" currency="$" separator="," :precision="Decimal" v-model="TotalTrimestre1" ></vue-numeric>
            </div>
            <div class="col-lg-2">
                <vue-numeric disabled placeholder="$ 0" class="form-control form-finanza form-control-sm text-center color-01 bold" currency="$" separator="," :precision="Decimal" v-model="TotalTrimestre2" ></vue-numeric>
            </div>
            <div class="col-lg-2">
                <vue-numeric disabled placeholder="$ 0" class="form-control form-finanza form-control-sm text-center color-01 bold" currency="$" separator="," :precision="Decimal" v-model="TotalTrimestre3" ></vue-numeric>
            </div>
            <div class="col-lg-2">
                <vue-numeric disabled placeholder="$ 0" class="form-control form-finanza form-control-sm text-center color-01 bold" currency="$" separator="," :precision="Decimal" v-model="TotalTrimestre4" ></vue-numeric>
            </div>
        </div>
	</div>
</template>

<script>
export default {
	name:'FormBase',
	props:['pEmitSeccion'],
	data() {
		return {
			IdCuenta:0,
			IdAnio:0,
			IdConfigS:0,
            ListaDetallesCuenta:[],
            TotalTrimestre1:0,
            TotalTrimestre2:0,
            TotalTrimestre3:0,
            TotalTrimestre4:0,
            Decimal:0,
            NumTabla:0,
			BndUnoT:false
		}
	},
	methods: {
		GetDetallesCuenta(Anio,IdConfigS,pListaDetallesCuenta,PrimerT,SegundoT,TercerT,CuartoT){
			this.Anio=Anio;
			this.IdConfigS=IdConfigS;
			this.ListaDetallesCuenta=pListaDetallesCuenta;
			this.TotalTrimestre1=0;
			this.TotalTrimestre2=0;
			this.TotalTrimestre3=0;
			this.TotalTrimestre4=0;
			
            this.TotalTrimestre1=isNaN(parseFloat(PrimerT)) ? 0 : parseFloat(PrimerT);
            this.TotalTrimestre2=isNaN(parseFloat(SegundoT)) ? 0 : parseFloat(SegundoT);
            this.TotalTrimestre3=isNaN(parseFloat(TercerT)) ? 0 : parseFloat(TercerT);
            this.TotalTrimestre4=isNaN(parseFloat(CuartoT)) ? 0 : parseFloat(CuartoT);
			// console.log(this.TotalTrimestre1);
			// SI YA EXISTEN VALORES EN EL TOTAL ANUAL, ESTE DEBE SER EL DEL PRIMER TRIMESTRE
			if (this.BndUnoT===true) {
				this.ListaDetallesCuenta.forEach((value) => {
					value.UnoT=value.BaseActual;
					// this.TotalTrimestre1+=parseFloat(value.UnoT);
				});	
			}
			// console.log(isNanthis.TotalTrimestre1);
			// this.TotalTrimestre1=isNaN(this.TotalTrimestre1) ? 0 : this.TotalTrimestre1;
			
		},
		GetTotalTrimestre(){
            this.TotalTrimestre1=0;
            this.TotalTrimestre2=0;
            this.TotalTrimestre3=0;
            this.TotalTrimestre4=0;
            this.ListaDetallesCuenta.forEach(element => {
				element.BaseActual=0;
                this.TotalTrimestre1+=parseFloat(element.UnoT);
                this.TotalTrimestre2+=parseFloat(element.DosT);
                this.TotalTrimestre3+=parseFloat(element.TresT);
                this.TotalTrimestre4+=parseFloat(element.CuatroT);
				element.BaseActual+=parseFloat(element.UnoT)+parseFloat(element.DosT)+parseFloat(element.TresT)+parseFloat(element.CuatroT);
            });
        },
		EnviarTotalTrimestres(){
			this.bus.$emit('IgualarTrimestres',this.Anio,this.IdConfigS,this.TotalTrimestre1,this.TotalTrimestre2,this.TotalTrimestre3,this.TotalTrimestre4);
		}
	},
	created() {
		this.bus.$off('PassDetallesCuenta');
        this.bus.$on('PassDetallesCuenta',(Anio,IdConfigS,DetallesCuenta,PrimerT,SegundoT,TercerT,CuartoT,BndUnoT)=>{
			this.BndUnoT=BndUnoT;
            this.GetDetallesCuenta(Anio,IdConfigS,DetallesCuenta,PrimerT,SegundoT,TercerT,CuartoT);
        });
		this.bus.$off('Save_'+this.pEmitSeccion);
        this.bus.$on('Save_'+this.pEmitSeccion,()=>{
            this.EnviarTotalTrimestres();
        });
	},
}
</script>

<style>

</style>
